/* Kaddanse — la caisse du disquaire (deck panier 09.09, go Lot 1 + 2 + P4).
   Trois rôles, tous côté page /cart ou tiroir :
     P3  la barre de commande mobile (total + POWER) qui suit quand le bouton
         du ticket est sorti de l'écran ;
     T2  le total qui « roule » à chaque changement (classe .kdd-roule, une
         fois, coupée par prefers-reduced-motion en CSS) ;
     M1  la mesure : panier_view, tiroir_ouvert, panier_/tiroir_retirer,
         panier_/tiroir_qte (les data-kdd-event des boutons sont lus par
         kdd-events.js — rien n'est compté deux fois).
     P4  les cartes « Ce qui va avec » se retirent quand leur produit entre
         au panier (la section n'est pas re-rendue par le morph).
   Fichier asset chargé en defer : un <script> inline dans une section
   réinjectée par le morph ne s'exécute jamais (piège documenté). */
(function () {
  'use strict';

  function push(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    } catch (e) { /* la mesure ne casse jamais la page */ }
  }

  var estPanier = document.body.classList.contains('template-cart');

  /* ---------- P3 : la barre de commande mobile ---------- */
  var io = null;
  function armeBarre() {
    var barre = document.querySelector('[data-kdd-barre]');
    if (!barre) return;
    var cible = document.querySelector('.template-cart .cart-summary #checkout');
    if (!cible || !('IntersectionObserver' in window)) {
      barre.setAttribute('data-kdd-barre-cachee', '');
      return;
    }
    if (io) io.disconnect();
    io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) barre.setAttribute('data-kdd-barre-cachee', '');
      else barre.removeAttribute('data-kdd-barre-cachee');
    }, { threshold: 0 });
    io.observe(cible);
  }

  /* ---------- T2 : le total qui roule ---------- */
  function armeRoule() {
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      if (el.__kddRoule !== undefined) return;
      el.__kddRoule = el.textContent.trim();
      new MutationObserver(function () {
        var t = el.textContent.trim();
        if (t === el.__kddRoule) return;
        el.__kddRoule = t;
        el.classList.remove('kdd-roule');
        void el.offsetWidth;
        el.classList.add('kdd-roule');
        majGestes();
      }).observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  /* ---------- P4 : cartes qui se retirent une fois le produit au panier ---------- */
  var gestesAttente = null;
  function majGestes() {
    var cartes = document.querySelectorAll('[data-kdd-pg-handle]');
    if (!cartes.length) return;
    if (gestesAttente) return;
    gestesAttente = setTimeout(function () {
      gestesAttente = null;
      var url = ((window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart') + '.js';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var h = {};
          (c.items || []).forEach(function (i) { h[i.handle] = 1; });
          var visibles = 0;
          cartes.forEach(function (el) {
            if (h[el.getAttribute('data-kdd-pg-handle')]) el.setAttribute('hidden', '');
            if (!el.hasAttribute('hidden')) visibles++;
          });
          var sec = document.querySelector('.kdd-pg');
          if (sec && !visibles) sec.setAttribute('hidden', '');
        })
        .catch(function () { /* rien : les cartes restent, sans conséquence */ });
    }, 400);
  }

  /* ---------- M1 : la mesure ---------- */
  function mesure() {
    if (estPanier) {
      var tot = document.querySelector('[data-cart-subtotal]');
      var n = document.querySelector('[ref="cartItemCount"]');
      push('panier_view', {
        kdd_label: tot ? (tot.getAttribute('value') || tot.textContent.trim()) : '',
        kdd_items: n ? (parseInt(n.textContent, 10) || 0) : 0
      });
    }
    var dlg = document.querySelector('#cart-drawer dialog');
    if (dlg && 'MutationObserver' in window) {
      new MutationObserver(function () { if (dlg.open) push('tiroir_ouvert', {}); })
        .observe(dlg, { attributes: true, attributeFilter: ['open'] });
    }
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var rm = e.target.closest('.cart-items__remove');
      if (rm) {
        var row = rm.closest('.cart-items__table-row');
        var t = row && row.querySelector('.cart-items__title');
        push(rm.closest('cart-drawer-component') ? 'tiroir_retirer' : 'panier_retirer', {
          kdd_label: t ? t.textContent.trim().slice(0, 80) : ''
        });
        return;
      }
      var q = e.target.closest('.cart-items__quantity .quantity-minus, .cart-items__quantity .quantity-plus');
      if (q) {
        var row2 = q.closest('.cart-items__table-row');
        var t2 = row2 && row2.querySelector('.cart-items__title');
        push(q.closest('cart-drawer-component') ? 'tiroir_qte' : 'panier_qte', {
          kdd_label: t2 ? t2.textContent.trim().slice(0, 80) : '',
          kdd_href: q.classList.contains('quantity-plus') ? '+1' : '-1'
        });
      }
    }, true);
  }

  /* ---------- armement + ré-armement après morph ---------- */
  function arme() {
    armeBarre();
    armeRoule();
    if ('MutationObserver' in window) {
      var attente = null;
      new MutationObserver(function () {
        if (attente) return;
        attente = setTimeout(function () { attente = null; armeBarre(); armeRoule(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { armeBarre(); armeRoule(); });
    mesure();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arme);
  else arme();
})();
